import { RepositoryFactory } from "@/repositories/RepositoryFactory";

const LevelsRepository = RepositoryFactory.get("levels");

const state = {
  levels: [],
  levelSelect: ["", "A1", "A2", "B1", "B2"],
  levelExercice: ["A1", "A2", "B1", "B2"],
  levelFilters: {
    A1: false,
    A2: false,
    B1: false,
    B2: false,
  },
};

const getters = {};

const actions = {
  getLevels({ dispatch, commit }, params = {}) {
    LevelsRepository.getLevels(params)
      .then((response) => {
        const levels = response.data;
        commit("SAVE_LEVELS", levels);
      })
      .catch(() => {
        dispatch(
          "notifications/addError",
          {
            message: state.$t(`message.notifications.level.getClassesError`),
          },
          { root: true },
        );
      });
  },
};

const mutations = {
  SAVE_LEVELS(state, levels) {
    state.levels = levels;
  },
};

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations,
};
